import { render, staticRenderFns } from "./ChangeBillType.vue?vue&type=template&id=39806e80"
import script from "./ChangeBillType.vue?vue&type=script&lang=js"
export * from "./ChangeBillType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports